import request from './request'

export default class Catalogos {

    constructor() {
        this.users_programs = [];
        this.programs_types = [];
        this.all_users = [];
        this.services = [];
        this.type_documents = [];
        this.payment_periods = [];
        this.banks = [];
        this.type_account = [];
        this.users_profile = [];
        this.buildings = [];
        this.concepts = [];
        this.companies_all = [];
        this.payments_recurrings = [];
        this.business_type = [];
        this.provider_types = [];
        this.type_payments = [];
        this.budgets_user = [];
        this.budgets_user_load = false;
        this.buys_user = [];
        this.buys_user_load = false;
        this.bills_user = [];
        this.departamens_buildings = [];
        this.folio_budgets = '';
        this.bills_types = [];
        this.companies_users = [];
        this.companies_buildings = [];
        this.companies = [];
        this.profiles = [];
        this.messages_user = [];
        this.billing_data_user = [];
        this.all_billing_data = [];
        this.bill_data_types = [];
        this.bank_account_provider = [];
        this.bank_account_company = [];
        this.bank_accounts_companies = [];
        this.bank_bill_account_provider = [];
        this.currencies = [];
        this.validatePaymentPlugin = [];
        this.checksCancel = [];
        this.taxes_types = [];
        this.type_increase = [];
        this.types_bill_number = [];
        this.count_bill_check = 0;
        this.count_checks_authorize = 0;
        this.count_paid_checks = 0;
        this.count_paid_payrolls = 0;
        this.count_paid_shares = 0;
        this.count_bill_check_new = 0;
        this.count_paid_checks_tax = 0;
        this.count_vacations_check = 0;
        this.buildings_resident = [];
        this.petty_cash_user = [];
        this.petty_cash_user_load = true;
        this.bank_accounts_companys = [];
        this.bank_accounts_groups = [];
        this.company_pays = [];
        this.company_user = [];
        this.type_departments = [];
        this.departamens_available = [];
        this.departments = [];
        this.count_tenant_departments = [];
        this.departamens_user = [];
        this.type_tax_regimes = [];
        this.type_cfdis = [];
        this.bills_group = [];
        this.departments_all = [];
        this.users_profiles = [];
        this.users_employees = [];
        this.users_juniors = [];
        this.checkbooks = [];
        this.folios_checkbooks = [];
        this.bank_company = [];
        this.rules_partners = [];
        this.rules_shares = [];
        this.share_taxes = [];
        this.users_investors = [];
        this.users_companies = [];
        this.contract_services_type = [];
        this.bank_account_all = [];
        this.bank_accounts_rules = [];
        this.providers_rules = [];
        this.pay_bill = [
            {value:'01', name:'Efectivo'},
            {value:'02', name:'Cheque nominativo'},
            {value:'03', name:'Transferencia electrónica de fondos'},
            {value:'04', name:'Tarjeta de crédito'},
            {value:'05', name:'Monedero electrónico'},
            {value:'06', name:'Dinero electrónico'},
            {value:'08', name:'Vales de despensa'},
            {value:'12', name:'Dación en pago'},
            {value:'13', name:'Pago por subrogación'},
            {value:'14', name:'Pago por consignación'},
            {value:'15', name:'Condonación'},
            {value:'17', name:'Compensación'},
            {value:'23', name:'Novación'},
            {value:'24', name:'Confusión'},
            {value:'25', name:'Remisión de deuda'},
            {value:'26', name:'Prescripción o caducidad'},
            {value:'27', name:'A satisfacción del acreedor'},
            {value:'28', name:'Tarjeta de débito'},
            {value:'29', name:'Tarjeta de servicios'},
            {value:'30', name:'Aplicación de anticipos'},
            {value:'31', name:'Intermediario pagos'},
            {value:'99', name:'Por definir'},
        ];

        const now = new Date();

        this.dateIni = new Date(
            now.getFullYear(),
            now.getMonth() - 1,
            1
        );

        this.dateEnd = new Date();

    }

    formatDate(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }

    async get_payment_periods() {
        let _endpoint = '/catalogue/payment_period';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.payment_periods = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_services() {
        let _endpoint = '/catalogue/services';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.services = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_type_documents() {
        let _endpoint = '/catalogue/type_documents';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.type_documents = data;
            }
        } catch (error) {
            console.log(error);
        }
    }



    async get_all_users(query = '') {
        let search = { _search: query };
        let _endpoint = '/catalogue/users';
        try {
            let { data } = await request.get(_endpoint, search)
            if (data) {
                this.all_users = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_banks() {
        let _endpoint = '/catalogue/banks';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.banks = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_type_account() {
        let _endpoint = '/catalogue/type_account';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.type_account = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_users_profile(ids) {
        let _endpoint = '/catalogue/users_profile/' + ids;
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.users_profile = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_users_employees() {
        let _endpoint = '/catalogue/users_employees';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.users_employees = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_users_juniors(id) {
        let _endpoint = '/catalogue/users_juniors/' + id;
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.users_juniors = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_buildings() {
        let _endpoint = '/catalogue/buildings';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.buildings = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_concepts() {
        let _endpoint = '/concept';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.concepts = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_payments_recurrings() {
        let _endpoint = '/catalogue/payments_recurrings';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.payments_recurrings = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_folio_budgets(id) {
        let _endpoint = '/catalogue/folio_budgets/' + id;
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.folio_budgets = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_business_type() {
        let _endpoint = '/business_type';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.business_type = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_provider_types() {
        let _endpoint = '/catalogue/provider_types';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.provider_types = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_type_payments() {
        let _endpoint = '/catalogue/type_payments';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.type_payments = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_type_payments_payroll() {
        let _endpoint = '/catalogue/type_payments_payroll';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.type_payments = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_type_payments_partners() {
        let _endpoint = '/catalogue/type_payments_partners';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.type_payments = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_type_payments_other_incomes() {
        let _endpoint = '/catalogue/type_payments_other_incomes';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.type_payments = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_budgets_user(user = '', concept_id = '', company_id = '') {
        this.budgets_user_load = true;
        let _endpoint = '/catalogue/budgets_user?user_id=' + user + '&concept_id=' + concept_id + '&company_id=' + company_id;
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.budgets_user_load = false;
                this.budgets_user = data;
            }
        } catch (error) {
            console.log(error);
            this.budgets_user_load = false;
        }
    }

    async get_buys_user(user = '', concept_id = '', company_id = '') {
        this.buys_user_load = true;
        let _endpoint = '/catalogue/buys_user?user_id=' + user + '&concept_id=' + concept_id + '&company_id=' + company_id;
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.buys_user = data;
                this.buys_user_load = false;
            }
        } catch (error) {
            console.log(error);
            this.buys_user_load = false;
        }
    }

    async get_bills_user(user = '', id = '') {
        let _endpoint = '/catalogue/bills_user?id=' + id + '&user_id=' + user;
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.bills_user = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_departamens_buildings(building = '') {
        let _endpoint = '/departments/list?building_id=' + building;
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.departamens_buildings = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_bills_types() {
        let _endpoint = '/catalogue/bills_types';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.bills_types = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_companies_users(user_id = '') {
        let _endpoint = '/catalogue/companies_users/' + user_id;
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.companies_users = data.companies;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_companies_buildings(building_id = '') {
        let _endpoint = '/catalogue/companies_buildings';
        if (building_id) {
            _endpoint = '/catalogue/companies_buildings/' + building_id;
        }
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                if (building_id) {
                    this.companies_buildings = data.companies;
                } else {
                    this.companies_buildings = data;
                }
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_companies_bills() {
        let _endpoint = '/catalogue/companies_bill_download';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.companies = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async getProfiles() {
        let _endpoint = '/catalogue/profiles';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.profiles = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async getMessagesuser(user_id) {
        let _endpoint = '/get_message_users?id=' + user_id;
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.messages_user = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async getBillingDataUser(user_id) {
        let _endpoint = user_id + '/billing_data';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.billing_data_user = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async getBillingDataType() {
        let _endpoint = '/catalogue/bill_data_type';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.bill_data_types = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async getBankAccountProvider(user_id) {
        let _endpoint = `/${user_id}/bank_account_provider`;
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.bank_account_provider = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async getBankBillAccountProvider(bill_id = false) {
        if (bill_id) {
            let _endpoint = '/catalogue/bill_bank/' + bill_id;
            try {
                let { data } = await request.get(_endpoint)
                if (data) {
                    this.bank_bill_account_provider = data.banks;
                } else {
                    this.bank_bill_account_provider = [];
                }
            } catch (error) {
                console.log(error);
            }
        } else {
            this.bank_bill_account_provider = [];
        }
    }

    async getBankAccountCompany(company_id = false) {
        if (company_id) {
            let _endpoint = '/companies/' + company_id;
            try {
                let { data } = await request.get(_endpoint)
                if (data) {
                    this.bank_account_company = data.bank_accounts;
                } else {
                    this.bank_account_company = [];
                }
            } catch (error) {
                console.log(error);
            }
        } else {
            this.bank_account_company = [];
        }
    }

      async getBankAccountsCompanies(companies_id) {
        if (companies_id) {
            let _endpoint = '/catalogue/bank_account_company';
            try {
                let { data } = await request.get(_endpoint,{
                    companies_id: companies_id                    
                })
                if (data) {
                    this.bank_accounts_companies = data;
                } else {
                    this.bank_accounts_companies = [];
                }
            } catch (error) {
                console.log(error);
            }
        } else {
            this.bank_accounts_companies = [];
        }
    }

    async getCurrencies() {
        let _endpoint = '/catalogue/currencies';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.currencies = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_validate_payment_plugin() {
        let search = {
            company_id: '',
            paid: 1,
            search: '',
            type_id: '',
            user_id: '',
            concept_id: '',
            biill_type_id: '',
            type_payment_id: '',
            billing_data_id: '',
            date: ['2024-07-01', '2030-12-31'],
            complement: 1
        };

        let _endpoint = '/pays';
        try {
            let { data } = await request.list(_endpoint, 1, search)
            if (data) {
                this.validatePaymentPlugin = data.data;

            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_check_cancel() {
        let search = {
            date: '',
            company_id: '',
            search: '',
            type_id: '',
            user_id: '',
            concept_id: '',
            type_payment_id: '',
            biill_type_id: '',
            billing_data_id: '',
            status: 2,
            authorized: 1,
        };

        let _endpoint = '/checks';
        try {
            let { data } = await request.list(_endpoint, 1, search)
            if (data) {
                this.checksCancel = data.data.data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_taxes_types() {
        let _endpoint = '/catalogue/taxes_types';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.taxes_types = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_all_billing_data() {
        let _endpoint = '/catalogue/all_billing_data';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.all_billing_data = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_companies_all() {
        let _endpoint = '/catalogue/companies';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.companies_all = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_type_increase() {
        let _endpoint = '/catalogue/type_increase';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.type_increase = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_count_bill_check() {
        let _endpoint = '/catalogue/get_count_bill_check';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.count_bill_check = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_count_bill_check_new() {
        let _endpoint = '/bills';
        try {

              
            let { data } = await request.get( _endpoint, {
                page: 1,
                _search: {
                    billing_data_id: '',
                    pay_order: '',
                    date: [this.formatDate(this.dateIni), this.formatDate(this.dateEnd)],
                    company_id: '',
                    user_id: '',
                    biill_type_id: '',
                    resident: 0
                },
            });

            // console.log(data);
            if (data) {
                this.count_bill_check_new = data.data.total;
            }
        } catch (error) {
            console.log(error);
        }
    }


    async get_count_vacations_check(id) {
        let _endpoint = '/catalogue/get_count_vacations_check/' + id;
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.count_vacations_check = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_checks_authorize() {
        let _endpoint = '/catalogue/get_checks_authorize';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.count_checks_authorize = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_paid_checks() {
        let _endpoint = '/catalogue/get_paid_checks';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.count_paid_checks = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_paid_payrolls() {
        let _endpoint = '/catalogue/get_paid_checks/1';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.count_paid_payrolls = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_paid_shares() {
        let _endpoint = '/catalogue/get_paid_checks/2';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.count_paid_shares = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_paid_checks_tax() {
        let _endpoint = '/catalogue/get_paid_checks_tax';
        this.count_paid_checks_tax = 0;
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.count_paid_checks_tax = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_types_bill_number() {
        let _endpoint = '/catalogue/types_bill_number';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.types_bill_number = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_buildings_resident(user_id) {
        let _endpoint = '/catalogue/building_resident/' + user_id;
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.buildings_resident = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_petty_cash_user(filter) {
        this.petty_cash_user_load = true;
                
        let search = {
            building_id: '',
            user_id: ''
        };
        if(filter.building_id){
            search.building_id = filter.building_id;
        }
        if(filter.user_id){
            search.user_id = filter.user_id;
        }
        let _endpoint = '/petty_cash_user';
        try {
            let { data } = await request.post(_endpoint, search)
            if (data) {
                this.petty_cash_user_load = false;
                this.petty_cash_user = data;
            }
        } catch (error) {
            console.log(error);
        }
    }


    async get_bank_accounts_companys(id) {       
        let _endpoint = '/catalogue/companies/company_banks/'+id;
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.bank_accounts_companys = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_company_pays() {
        let _endpoint = '/catalogue/company_pays';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.company_pays = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_company_user_payroll(company_id) {
        let _endpoint = '/catalogue/company_user_payroll/'+company_id;
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.company_user = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_company_user_partner(company_id) {
        let _endpoint = '/catalogue/company_user_partner/'+company_id;
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.company_user = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_type_departments() {
        let _endpoint = '/catalogue/type_departments';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.type_departments = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_departamens_buildings_available(building = '', departments = [], open = 0) {
        let _endpoint = '/catalogue/available_apartment?building_id=' + building+'&department_ids='+departments+'&open='+open;
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.departamens_available = data;
            }
        } catch (error) {
            console.log(error);
        }
    }


    async get_count_tenant_departments() {
        let _endpoint = '/catalogue/indivisos_tenants_count';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.count_tenant_departments = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_departamens_user(user = '') {
        let _endpoint = '/departments/list-user?user_id=' + user;
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.departamens_user = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_type_tax_regimes() {
        let _endpoint =  '/catalogue/type_tax_regimes';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.type_tax_regimes = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_type_cfdis() {
        let _endpoint =  '/catalogue/type_cfdis';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.type_cfdis = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_bills_group(company_id, method_payment, user_id) {
        let _endpoint =  '/catalogue/bills_group?company_id='+company_id+'&method_payment='+method_payment+'&user_id='+user_id;
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.bills_group = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_departments_all() {
        let _endpoint = '/catalogue/departments_all';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.departments_all = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_users_profiles(ids) {
        let _endpoint = '/catalogue/users_profiles?ids=' + ids;
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.users_profiles = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_checkbooks_company(company_id) {
        let _endpoint = '/catalogue/checkbook_company?company_id=' + company_id;
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.checkbooks = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_folio_checkbook(id) {
        let _endpoint = '/catalogue/checkbook_company_folio?checkbook_id=' + id;
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.folio_checkbook = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async getFoliosCheckbooks($checkbook_id, $folio = '') {
        let _endpoint = '/catalogue/checkbook_folios?checkbook_id=' + $checkbook_id + '&folio=' + $folio;        
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.folios_checkbooks = data;
            }
        } catch (error) {
            console.log(error);
        }
    }
    
    async getBankCompany($company_id, $bank_id) {
        let _endpoint = '/catalogue/bank_company?company_id=' + $company_id + '&bank_id=' + $bank_id;        
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.bank_company = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async getUsersInvestors() {
        let _endpoint = '/catalogue/get_investors';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.users_investors = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async getUsersCompanies(companyIds) {
        let _endpoint = '/catalogue/get_users_companies';
        try {
            let { data } = await request.post(_endpoint, {
                company_ids: companyIds
            });
            if (data) {
                this.users_companies = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_rules_partners() {
        let _endpoint = '/catalogue/rules_partners';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.rules_partners = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_rules_shares() {
        let _endpoint = '/catalogue/rules_shares';        
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.rules_shares = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_share_taxes() {
        let _endpoint = '/catalogue/share_taxes';        
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.share_taxes = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async getContractServicesType() {
        let _endpoint = '/catalogue/services_contract_type';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.contract_services_type = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async getProgramsTypes() {
        let _endpoint = '/catalogue/program_type';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.programs_types = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_users_programs(program_id) {
        let _endpoint = '/catalogue/programs/users/' + program_id;
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.users_programs = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_bank_accounts_groups(group_id) {
        let _endpoint = '/catalogue/bank_accounts_groups/' + group_id;
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.bank_accounts_groups = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async getBankAccountAll() {
        let _endpoint = '/bank_accounts';
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.bank_account_all = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_bank_accounts_rules(type) {
        let _endpoint = '/catalogue/bank_accounts_rules?id=' + type;
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.bank_accounts_rules = data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async get_providers_rules(type) {
        let _endpoint = '/catalogue/providers_rules?id=' + type;
        try {
            let { data } = await request.get(_endpoint)
            if (data) {
                this.providers_rules = data;
            }
        } catch (error) {
            console.log(error);
        }
    }
}